import { getGlobals } from "storyblok/api"
import { getVideoLibraryCategoriesPaths, getCategoryArchiveVideos, getAllArchiveVideoCategories } from "storyblok/videoLibrary"
import Meta from "components/Meta"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import VideoCard from "components/VideoCard"
import { getCategoryArchiveVideosApi } from "storyblok/videoLibraryApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function VideoCategoryArchive({ category, items, categories, perPage, total, currentPage }) {
  return (
    <>
      <Meta info={{ title: `${category.name}`, og_title: `${category.name}`, twitter_title: `${category.name}` }} />
      <main data-pagefind-ignore="all">
        <PageHeader
          blok={{
            type: "standard",
            heading: category.name,
            breadcrumbs: [{ text: "Video Library", href: "/video-library" }, { text: category.name }],
          }}
        />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/video-library"
          categoryLinkPrefix="/video-library/category/"
          currentTab={category}
          list={<CardListSection
            key={category.value}
            items={items}
            total={total}
            perPage={perPage}
            currentPage={currentPage}
            columns={3}
            category={category.value}
            handler={(params) => getCategoryArchiveVideosApi(params)}
            Card={VideoCard} />}
        />
      </main>
    </>
  )
}

export async function getStaticProps({ params: { category } }) {
  const globals = await getGlobals()
  const categories = await getAllArchiveVideoCategories()
  const { items, currentPage, total, perPage } = await getCategoryArchiveVideos({ category })

  return {
    props: {
      category: { name: category.replaceAll("-", " "), value: category },
      items: items ?? null,
      perPage,
      total,
      currentPage,
      categories: categories ?? null,
      globals: globals ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getVideoLibraryCategoriesPaths(),
    fallback: false,
  }
}
